import { connect } from "react-redux";
import { getLang } from "../../reducers/crossword/selectors";
import { setLang } from "../../reducers/crossword/uriActions";
import { getShowLanguages } from "../../reducers/ui/selectors";
import { toggleLanguages } from "../../reducers/ui/actions";

import Languages from "./Languages";

const mapStateToProps = state => ({
  show: getShowLanguages(state),
  lang: getLang(state)
});

const mapDispatchToProps = dispatch => ({
  setLang: lang => dispatch(setLang(lang)),
  hideLanguages: () => dispatch(toggleLanguages(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(Languages);



// WEBPACK FOOTER //
// ./src/components/Languages/LanguagesContainer.js